// SPDX-License-Identifier: Apache-2.0

// Journey — `/journey` route. Mounts the standalone 3D narration walkthrough
// (lives at `public/journey/index.html`, copied verbatim from
// `~/tether-brain-v2/journey/journey.html`) inside an iframe.
//
// Iframe boundary keeps the journey's own importmap (three@0.160.0 from
// unpkg) isolated from v2's pinned three@0.171.0, and preserves the
// browser back-button so SPA shell navigation still works.
export default function Journey() {
  return (
    <div style={{ position: "fixed", inset: 0, "background": "#000", "z-index": 1000 }}>
      <iframe
        src="/journey/index.html"
        style={{ border: 0, width: "100%", height: "100%", display: "block" }}
        title="Your Magic Notebook — A Journey"
      />
    </div>
  );
}
